'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyHierarchicalCodesToDim = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addParentId = function addParentId(id, ids) {
  var last = R.last(ids);
  return R.append(R.isNil(last) ? id : last + '.' + id, ids);
};

var refineUnconfirmedPaths = function refineUnconfirmedPaths(paths) {
  var confirmedPaths = R.filter(function (p) {
    return p.length === 1;
  }, paths);
  if (!R.isEmpty(confirmedPaths)) {
    confirmedPaths = R.reduce(function (acc, k) {
      if (R.has(k, acc)) {
        return acc;
      }
      var ps = R.prop(k, paths);
      var flatConfirmed = R.unnest(R.values(acc));
      var filtered = R.filter(function (p) {
        return !!R.find(function (cP) {
          return R.includes(p, cP) || R.includes(cP, p);
        }, flatConfirmed);
      }, ps);
      if (!R.isEmpty(filtered)) {
        return R.assoc(k, [R.head(filtered)], acc);
      }
      return acc;
    }, confirmedPaths, R.keys(paths));
  }
  var remainingIds = R.reject(function (id) {
    return R.has(id, confirmedPaths);
  }, R.keys(paths));
  var getCommonPaths = function getCommonPaths(ids) {
    var _R$reduce = R.reduce(function (acc, id) {
      var ps = R.prop(id, paths);
      if (R.isEmpty(acc.commonPaths)) {
        return R.assoc('commonPaths', ps, acc);
      }
      var common = R.intersection(acc.commonPaths, ps);
      return R.isEmpty(common) ? R.assoc('rejectedChildrenIds', id, acc) : R.assoc('commonPaths', common, acc);
    }, { commonPaths: [], rejectedIds: [] })(ids),
        commonPaths = _R$reduce.commonPaths,
        rejectedIds = _R$reduce.rejectedIds;

    if (!R.isEmpty(rejectedIds)) {
      return R.append(R.head(commonPaths), getCommonPaths(rejectedIds));
    }
    return [R.head(commonPaths)];
  };
  var commons = getCommonPaths(remainingIds);
  return R.reduce(function (acc, id) {
    return R.assoc(id, R.intersection(commons, R.prop(id, paths)), acc);
  }, confirmedPaths, remainingIds);
};

var applyHierarchicalCodesToDim = exports.applyHierarchicalCodesToDim = function applyHierarchicalCodesToDim(hCodes, dim) {
  var confirmedHierarchisedChilds = new _set2.default([]);
  var unconfirmedPaths = {};

  var indexedValues = R.reduce(function (acc, val) {
    if (!val.isSelected) {
      return acc;
    }
    return R.assoc(val.id, val, acc);
  }, {}, dim.values || []);

  var parseHCodes = function parseHCodes(parentsDef, parentsInDim) {
    return R.reduce(function (acc, hC) {
      var codeID = hC.codeID,
          _hC$hierarchicalCodes = hC.hierarchicalCodes,
          hierarchicalCodes = _hC$hierarchicalCodes === undefined ? [] : _hC$hierarchicalCodes;

      var hasInDim = R.has(codeID, indexedValues);
      var isUnconfirmed = R.length(parentsInDim) !== R.length(parentsDef);
      var children = parseHCodes(R.append(codeID, parentsDef), hasInDim ? addParentId(codeID, parentsInDim) : parentsInDim)(hierarchicalCodes);
      if (!hasInDim) {
        return R.concat(acc, children);
      }
      var path = R.join('.', parentsDef);
      var val = (0, _extends3.default)({}, R.prop(codeID, indexedValues), {
        path: path,
        parents: parentsInDim,
        parent: R.last(parentsInDim),
        children: children
      });

      if (isUnconfirmed) {
        unconfirmedPaths = R.over(R.lensProp(val.id), function (paths) {
          return R.append(path, paths || []);
        }, unconfirmedPaths);
        val = R.assoc('unconfirmed', true, val);
        return R.append(val, acc);
      }
      confirmedHierarchisedChilds.add(codeID);
      return R.append(val, acc);
    }, []);
  };

  var parsed = parseHCodes([], [])(hCodes);

  var _unconfirmedPaths = R.pipe(R.reject(function (id) {
    return confirmedHierarchisedChilds.has(id);
  }), function (ids) {
    return R.pick(ids, unconfirmedPaths);
  })(R.keys(unconfirmedPaths));

  var refinedUnconfirmedPaths = refineUnconfirmedPaths(_unconfirmedPaths);

  var flattenDescendants = R.reduce(function (acc, val) {
    var children = flattenDescendants(val.children || []);
    return R.concat(acc, R.prepend(val, children));
  }, []);

  var isValid = function isValid(val) {
    return !val.unconfirmed || R.includes(val.path, R.propOr([], val.id, refinedUnconfirmedPaths));
  };

  var refineCodes = R.reduce(function (acc, hC) {
    var _flatDescendants = flattenDescendants(hC.children);
    var flatDescendants = R.prepend(hC, _flatDescendants);
    var validDescendant = R.find(isValid, flatDescendants);
    if (!validDescendant) {
      return acc;
    }
    var refined = R.pipe(R.map(function (v) {
      confirmedHierarchisedChilds.add(v.id);
      return R.omit(['unconfirmed', 'children', 'path'], v);
    }))(flatDescendants);
    return R.concat(acc, refined);
  }, []);

  var refined = refineCodes(parsed);

  var missingValues = R.pipe(R.keys, R.filter(function (id) {
    return !confirmedHierarchisedChilds.has(id);
  }), function (ids) {
    return R.props(ids, indexedValues);
  }, R.map(function (v) {
    return (0, _extends3.default)({}, v, { parents: [], parent: undefined });
  }), R.sortBy(R.propOr(-1, '__indexPosition')))(indexedValues);

  var hierarchicalIndexes = {};
  return R.pipe(R.concat, R.addIndex(R.map)(function (v, ind) {
    var parents = R.props(v.parents, hierarchicalIndexes);
    var hierId = R.last(v.parents) ? R.last(v.parents) + '.' + v.id : v.id;
    hierarchicalIndexes[hierId] = ind;
    return (0, _extends3.default)({}, v, {
      parents: parents,
      __indexPosition: ind
    });
  }), function (values) {
    return (0, _extends3.default)({}, dim, { values: values });
  })(missingValues, refined);
};